export const fiCustom = {
    headlines: {
      error: "Tapahtui virhe",
      loginEmail: "Kirjaudu tai luo tili",
      loginEmailNoSignup: "Kirjaudu tai luo tili",
      loginFinished: "Kirjautuminen onnistui",
      loginPasscode: "Syötä kertakoodi",
      loginPassword: "Syötä salasana",
      registerAuthenticator: "Passkey on valinnainen",
      registerConfirm: "Luo tili?",
      registerPassword: "Aseta uusi salasana",
      otpSetUp: "Määritä todennussovellus",
      profileEmails: "Sähköpostiosoitteet",
      profilePassword: "Salasana",
      profilePasskeys: "Passkeyt",
      isPrimaryEmail: "Ensisijainen sähköpostiosoite",
      setPrimaryEmail: "Aseta ensisijainen sähköposti",
      createEmail: "Syötä uusi sähköposti",
      createUsername: "Syötä uusi käyttäjänimi",
      emailVerified: "Vahvistettu",
      emailUnverified: "Vahvistamaton",
      emailDelete: "Poista",
      renamePasskey: "Nimeä passkey uudelleen",
      deletePasskey: "Poista passkey",
      lastUsedAt: "Viimeksi käytetty",
      createdAt: "Luotu",
      connectedAccounts: "Yhdistetyt tilit",
      deleteAccount: "Poista tili",
      accountNotFound: "Tiliä ei löytynyt",
      signIn: "Kirjaudu tai luo tili",
      signUp: "Aloita syöttämällä sähköpostisi",
      selectLoginMethod: "Valitse kirjautumistapa",
      setupLoginMethod: "Valitse kirjautumistapa",
      lastUsed: "Viimeksi nähty",
      ipAddress: "IP-osoite",
      revokeSession: "Peruuta istunto",
      profileSessions: "Istunnot",
      mfaSetUp: "Lisäsuojaus on valinnainen",
      securityKeySetUp: "Lisää turva-avain",
      securityKeyLogin: "Turva-avain",
      otpLogin: "Todennuskoodi",
      renameSecurityKey: "Nimeä turva-avain uudelleen",
      deleteSecurityKey: "Poista turva-avain",
      securityKeys: "Turva-avaimet",
      authenticatorApp: "Todennussovellus",
      authenticatorAppAlreadySetUp: "Todennussovellus on määritetty",
      authenticatorAppNotSetUp: "Määritä todennussovellus",
      trustDevice: "Luotatko tähän selaimeen?",
    },
    texts: {
      enterPasscode: "Syötä sähköpostiisi lähetetty kertakoodi. Tarkistathan myös roskapostisi.",
      enterPasscodeNoEmail: "Syötä ensisijaiseen sähköpostiisi lähetetty kertakoodi. Tarkistathan myös roskapostisi.",
      setupPasskey: "Voit luoda passkeyn nopeampaa kirjautumista varten tai ohittaa tämän ja ottaa sen käyttöön myöhemmin asetuksista. Biometriset tiedot tallennetaan vain laitteillesi.",
      createAccount: 'Tilille "{emailAddress}" ei ole olemassa tiliä. Haluatko luoda uuden?',
      otpEnterVerificationCode: "Syötä todennussovelluksesta saatu kertakoodi:",
      otpScanQRCode: "Skannaa QR-koodi todennussovelluksella (esim. Google Authenticator tai muu TOTP-sovellus). Vaihtoehtoisesti voit syöttää salaisen avaimen manuaalisesti.",
      otpSecretKey: "OTP-salainen avain",
      passwordFormatHint: "Pituuden tulee olla {minLength}–{maxLength} merkkiä.",
      securityKeySetUp: "Käytä USB-, Bluetooth- tai NFC-turva-avainta tai puhelintasi. Yhdistä tai aktivoi avain ja seuraa ohjeita rekisteröinnin viimeistelyyn.",
      setPrimaryEmail: "Aseta tämä sähköposti ensisijaiseksi yhteydenottoa varten.",
      isPrimaryEmail: "Tätä sähköpostia käytetään yhteydenottoon tarvittaessa.",
      emailVerified: "Tämä sähköposti on vahvistettu.",
      emailUnverified: "Tätä sähköpostia ei ole vahvistettu.",
      emailDelete: "Jos poistat tämän sähköpostin, sitä ei voi enää käyttää kirjautumiseen.",
      renamePasskey: "Anna passkeylle nimi.",
      deletePasskey: "Poista tämä passkey tililtäsi.",
      deleteAccount: "Haluatko varmasti poistaa tilin? Kaikki tiedot poistetaan pysyvästi.",
      noAccountExists: 'Tilille "{emailAddress}" ei ole olemassa tiliä.',
      selectLoginMethodForFutureLogins: "Voit valita kirjautumistavan nyt tai ohittaa tämän ja viimeistellä profiilin ensin.",
      howDoYouWantToLogin: "Miten haluat kirjautua?",
      mfaSetUp: "Voit ottaa MFA:n käyttöön nyt tai ohittaa tämän ja määrittää sen myöhemmin asetuksista.",
      securityKeyLogin: "Yhdistä tai aktivoi turva-avain ja seuraa ohjeita kirjautumisen viimeistelyyn.",
      otpLogin: "Avaa todennussovellus ja syötä kertakoodi kenttään.",
      renameSecurityKey: "Anna turva-avaimelle nimi.",
      deleteSecurityKey: "Poista tämä turva-avain tililtäsi.",
      authenticatorAppAlreadySetUp: "Tilisi on suojattu todennussovelluksella, joka tuottaa kertakoodeja (TOTP).",
      authenticatorAppNotSetUp: "Suojaa tilisi todennussovelluksella, joka tuottaa kertakoodeja (TOTP).",
      trustDevice: "Jos luotat tähän selaimeen, sinun ei tarvitse käyttää MFA:ta seuraavalla kirjautumiskerralla.",
    },
    labels: {
      or: "tai",
      no: "ei",
      yes: "kyllä",
      email: "Sähköposti",
      continue: "Jatka",
      copied: "kopioitu",
      skip: "Ohita nyt",
      save: "Tallenna",
      password: "Salasana",
      passkey: "Passkey",
      passcode: "Kertakoodi",
      signInPassword: "Kirjaudu salasanalla",
      signInPasscode: "Kirjaudu kertakoodilla",
      forgotYourPassword: "Unohditko salasanasi?",
      back: "Takaisin",
      signInPasskey: "Kirjaudu passkeyllä",
      registerAuthenticator: "Luo passkey",
      signIn: "Kirjaudu sisään",
      signUp: "Luo tili",
      sendNewPasscode: "Lähetä uusi koodi",
      passwordRetryAfter: "Yritä uudelleen {passwordRetryAfter} kuluttua",
      passcodeResendAfter: "Pyydä uusi koodi {passcodeResendAfter} kuluttua",
      unverifiedEmail: "vahvistamaton",
      primaryEmail: "ensisijainen",
      setAsPrimaryEmail: "Aseta ensisijaiseksi",
      verify: "Vahvista",
      delete: "Poista",
      newEmailAddress: "Uusi sähköpostiosoite",
      newPassword: "Uusi salasana",
      rename: "Nimeä uudelleen",
      newPasskeyName: "Uusi passkeyn nimi",
      addEmail: "Lisää sähköposti",
      createPasskey: "Luo passkey",
      webauthnUnsupported: "Passkeyt eivät ole tuettuja selaimessasi",
      signInWith: "Jatka palvelulla {provider}",
      deleteAccount: "Kyllä, poista tämä tili.",
      emailOrUsername: "Sähköposti tai käyttäjänimi",
      username: "Käyttäjänimi",
      optional: "valinnainen",
      dontHaveAnAccount: "Eikö sinulla ole tiliä?",
      alreadyHaveAnAccount: "Sinulla on jo tili?",
      changeUsername: "Vaihda käyttäjänimi",
      setUsername: "Aseta käyttäjänimi",
      changePassword: "Vaihda salasana",
      setPassword: "Aseta salasana",
      revoke: "Peruuta",
      currentSession: "Nykyinen istunto",
      authenticatorApp: "Todennussovellus",
      securityKey: "Turva-avain",
      securityKeyUse: "Käytä turva-avainta",
      newSecurityKeyName: "Uusi turva-avaimen nimi",
      createSecurityKey: "Lisää turva-avain",
      authenticatorAppManage: "Hallitse todennussovellusta",
      authenticatorAppAdd: "Määritä",
      configured: "määritetty",
      useAnotherMethod: "Käytä toista menetelmää",
      lastUsed: "Viimeksi käytetty",
      trustDevice: "Luota tähän selaimeen",
      staySignedIn: "Pysy kirjautuneena",
    },
    errors: {
      somethingWentWrong: "Tapahtui tekninen virhe. Yritä myöhemmin uudelleen.",
      requestTimeout: "Pyyntö aikakatkaistiin.",
      invalidPassword: "Virheellinen sähköposti tai salasana.",
      invalidPasscode: "Syötetty kertakoodi ei ole oikea.",
      passcodeAttemptsReached: "Liian monta virheellistä yritystä. Pyydä uusi koodi.",
      tooManyRequests: "Liian monta pyyntöä. Odota ennen kuin yrität uudelleen.",
      unauthorized: "Istunto on vanhentunut. Kirjaudu uudelleen.",
      invalidWebauthnCredential: "Tätä passkeytä ei voi enää käyttää.",
      passcodeExpired: "Kertakoodi on vanhentunut. Pyydä uusi.",
      userVerification: "Käyttäjän todennus vaaditaan. Varmista, että laitteesi on suojattu PIN-koodilla tai biometrisellä tunnistuksella.",
      emailAddressAlreadyExistsError: "Sähköpostiosoite on jo käytössä.",
      maxNumOfEmailAddressesReached: "Et voi lisätä enempää sähköpostiosoitteita.",
      thirdPartyAccessDenied: "Pääsy estetty. Käyttäjä peruutti pyynnön tai palveluntarjoaja esti pääsyn.",
      thirdPartyMultipleAccounts: "Tiliä ei voitu tunnistaa. Sähköpostiosoite liittyy useaan tiliin.",
      thirdPartyUnverifiedEmail: "Sähköpostin vahvistus vaaditaan. Vahvista sähköposti palveluntarjoajasi kautta.",
      signupDisabled: "Tilin luominen on estetty.",
      handlerNotFoundError: "Nykyistä vaihetta ei tueta tässä sovellusversiossa. Yritä myöhemmin uudelleen tai ota yhteyttä tukeen.",
    },
    flowErrors: {
      technical_error: "Tapahtui tekninen virhe. Yritä myöhemmin uudelleen.",
      flow_expired_error: "Istunto on vanhentunut, aloita uudelleen painamalla nappia.",
      value_invalid_error: "Syötetty arvo on virheellinen.",
      passcode_invalid: "Syötetty kertakoodi ei ole oikea.",
      passkey_invalid: "Tätä passkeytä ei voi enää käyttää.",
      passcode_max_attempts_reached: "Liian monta virheellistä yritystä. Pyydä uusi koodi.",
      rate_limit_exceeded: "Liian monta pyyntöä. Odota ennen kuin yrität uudelleen.",
      unknown_username_error: "Käyttäjänimeä ei tunnistettu.",
      unknown_email_error: "Sähköpostiosoitetta ei tunnistettu.",
      username_already_exists: "Käyttäjänimi on jo käytössä.",
      invalid_username_error: "Käyttäjänimi saa sisältää vain kirjaimia, numeroita ja alaviivoja.",
      email_already_exists: "Sähköposti on jo käytössä.",
      not_found: "Pyydetty resurssi ei löytynyt.",
      operation_not_permitted_error: "Toiminto ei ole sallittu.",
      flow_discontinuity_error: "Prosessia ei voi jatkaa käyttäjäasetusten tai palveluntarjoajan määritysten vuoksi.",
      form_data_invalid_error: "Lomakkeen tiedoissa on virheitä.",
      unauthorized: "Istunto on vanhentunut. Kirjaudu uudelleen.",
      value_missing_error: "Arvo puuttuu.",
      value_too_long_error: "Arvo on liian pitkä.",
      value_too_short_error: "Arvo on liian lyhyt.",
      webauthn_credential_invalid_mfa_only: "Tätä tunnistetta voi käyttää vain toisen vaiheen turva-avaimena.",
      webauthn_credential_already_exists: "Pyyntö aikakatkaistiin, peruutettiin tai laite on jo rekisteröity. Yritä uudelleen tai käytä toista laitetta.",
      platform_authenticator_required: "Tilisi vaatii alustakohtaisia todennuslaitteita, mutta nykyinen laite tai selain ei tue niitä. Yritä toisella laitteella tai selaimella.",
      third_party_access_denied: "Pääsy estetty. Käyttäjä peruutti pyynnön tai palveluntarjoaja esti pääsyn.",
    }
};
